module.exports = __webpack_public_path__ + "img/requestCssFull.6d8f86ff.svg";